// ═══════════════════════════════════════════════════════════════════════════
// ErrorBoundary — a top-level safety net. If any component below it throws
// during render, React unmounts the tree; without a boundary that leaves a
// blank white screen (as happened with the missing ArrowUpIcon). This catches
// the crash and shows a recoverable fallback instead, keeping the rest of the
// app shell (background, player) alive.
// ═══════════════════════════════════════════════════════════════════════════

import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Surface loudly for logs/monitoring — never swallow silently.
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] caught a render error:', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="app-error-fallback" role="alert">
          <div className="app-error-card">
            <div className="app-error-mark" aria-hidden>epio<span>.</span></div>
            <h1>Something went wrong.</h1>
            <p>The app hit an unexpected error. Reloading usually fixes it.</p>
            <button type="button" className="app-error-btn" onClick={() => { try { window.location.reload(); } catch {} }}>
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
